import {
  ControlledCheckbox,
  ControlledSelect
} from 'components/shared/ControlledFields';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import {
  careReceiverNameFormatOptions,
  masterDataApplicationOptions,
  workforceManagementApplicationOptions
} from '../utils';
import { isSDBAccount } from 'utils/misc';
import { useSelector } from 'hooks';
import { Box, InputAdornment } from '@mui/material';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';

const FormContent = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();
  const { hasMultiResourcePlanningModule } = useSelector(
    ({ grants }) => grants
  );

  return (
    <Box
      sx={{
        '& section': { pt: 0.5 },
        '& .MuiBox-root': { maxWidth: '100%', textWrap: 'balance' }
      }}
    >
      <MultiStepForm.Section
        title={t('negativeAvailabilitySettings.activityPlanning')}
      >
        <ControlledNumericField
          name="neg_hours_base"
          label={t('negativeAvailabilitySettings.neg_hours_base')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('negativeAvailabilitySettings.hours')}
              </InputAdornment>
            )
          }}
        />
        <ControlledNumericField
          name="neg_hours_factor"
          label={t('negativeAvailabilitySettings.neg_hours_factor')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('negativeAvailabilitySettings.percent')}
              </InputAdornment>
            )
          }}
        />
        <ControlledNumericField
          name="neg_hours_min_time_block"
          label={t('negativeAvailabilitySettings.neg_hours_min_time_block')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('negativeAvailabilitySettings.hours')}
              </InputAdornment>
            )
          }}
        />
      </MultiStepForm.Section>

      {isSDBAccount() && (
        <MultiStepForm.Section title={t('activityPlanningSettings.title')}>
          <ControlledSelect
            control={control}
            label={t(
              'activityPlanningSettings.activity_planning_masterdata_application'
            )}
            name="activity_planning_masterdata_application"
            options={masterDataApplicationOptions}
          />

          <ControlledSelect
            control={control}
            label={t(
              'activityPlanningSettings.activity_planning_workforcemanagement_application'
            )}
            name="activity_planning_workforcemanagement_application"
            options={workforceManagementApplicationOptions}
          />
        </MultiStepForm.Section>
      )}

      {hasMultiResourcePlanningModule && (
        <>
          <MultiStepForm.Section
            title={t('activityPlanningSettings.activitySuggestions')}
          >
            <ControlledCheckbox
              control={control}
              name="activity_planning_activity_suggestions_enableActivityGlobalSearch"
              label={t(
                'activityPlanningSettings.activity_planning_activity_suggestions_enableActivityGlobalSearch'
              )}
            />

            <ControlledCheckbox
              control={control}
              name="activity_planning_activity_suggestions_showActivitiesWithoutRequirementAsSuggestion"
              label={t(
                'activityPlanningSettings.activity_planning_activity_suggestions_showActivitiesWithoutRequirementAsSuggestion'
              )}
            />
          </MultiStepForm.Section>

          <MultiStepForm.Section
            title={t('careReceiverNameFormatSettings.title')}
          >
            <ControlledSelect
              control={control}
              name="care_receiver_adult_name_format"
              label={t('careReceiverNameFormatSettings.adult_name_format')}
              options={careReceiverNameFormatOptions}
            />
            <ControlledSelect
              control={control}
              name="care_receiver_child_name_format"
              label={t('careReceiverNameFormatSettings.child_name_format')}
              options={careReceiverNameFormatOptions}
            />
            <ControlledNumericField
              name="care_receiver_age_threshold_child"
              label={t('careReceiverNameFormatSettings.age_threshold_child')}
              step={1}
              minValue={0}
              maxValue={99}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {t('careReceiverNameFormatSettings.year')}
                  </InputAdornment>
                )
              }}
            />
          </MultiStepForm.Section>
        </>
      )}
    </Box>
  );
};

export default FormContent;
